import axios, { AxiosRequestConfig , AxiosResponse, AxiosError} from 'axios';
import { fetchNewToken } from '../services/authServices';

let isRefreshing = false;
let refreshSubscribers: ((newToken: string) => void)[] = [];
const subscribeTokenRefresh = (callback: (newToken: string) => void) => {
  refreshSubscribers.push(callback);
};
const onRefreshed = (newToken: string) => {
  refreshSubscribers.forEach(callback => callback(newToken));
  refreshSubscribers = [];
};
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Accept': 'application/json',
  },
});
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers!['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);
// instance.interceptors.request.use(
//   config => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   error => Promise.reject(error)
// );

// Response interceptor to handle token refresh
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;  // Return the response if successful
  },
  async error => {
    const originalRequest = error.config;

    // If the response is a 401 and the request hasn't been retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Check if a token refresh is already in progress
      if (!isRefreshing) {
        isRefreshing = true;

        try {
          // Call refresh token API
          const newAccessToken = await fetchNewToken();
          axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken.accessToken}`;
          localStorage.setItem('token', newAccessToken.accessToken);
          localStorage.setItem('refreshToken', newAccessToken.refreshToken);
          // Retry all the requests that were waiting for the token to refresh
          onRefreshed(newAccessToken);
          isRefreshing = false;
          
          // Update the authorization header and retry the original request
          axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

          return axiosInstance(originalRequest);  // Retry the original request
        } catch (refreshError) {
          // Refresh token failed, log out the user or redirect to login
          isRefreshing = false;
          localStorage.clear();  // Clear tokens from storage
          return Promise.reject(refreshError);
        }
      }

      // If the token is being refreshed, queue the request until it's done
      return new Promise((resolve) => {
        subscribeTokenRefresh((newToken: string) => {
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          resolve(axiosInstance(originalRequest));
        });
      });
    }

    return Promise.reject(error);
  }
);

// instance.interceptors.response.use(
//   response => response,
//   async error => {
//     const originalRequest = error.config;

//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         const newToken = await fetchNewToken();
//         if (newToken && newToken.accessToken) {
//           // Set new token in the headers
//           instance.defaults.headers.common['Authorization'] = `Bearer ${newToken.accessToken}`;
//           localStorage.setItem('token', newToken.accessToken);
//           localStorage.setItem('refreshToken', newToken.refreshToken);

//           // Retry the original request
//           return instance(originalRequest);
//         } else {
//           throw new Error('No new token received');
//         }
//       } catch (e) {
//         console.error('Token refresh failed', e);
//         // Clear local storage and redirect to login
//         // localStorage.clear();
//         // sessionStorage.clear();
//         // window.location.href = '/login'; 
//         return Promise.reject(e);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
